module.exports = __webpack_public_path__ + "static/img/BM.4ef6b8b5.svg";